import { useAgentStore, useChatStore, useSessionId } from "@/sdk";
import { useTypedMostRecentTask } from "@/sdk/agent/hooks/useMostRecentTask";
import { usePartner } from "@/sdk/agent/hooks/usePartner";
import { useProductOfferStore } from "../../stores";
import type { CommunicationType } from "../types";
import { type SendNotificationResponse, sendNotification } from "./api/sendNotification";

export const useHandleSendLink = () => {
    const sessionId = useSessionId();
    const agentId = useAgentStore((state) => state.agentId);

    const { isVoice, isChat } = useTypedMostRecentTask();
    const primaryProducts = useProductOfferStore((state) => state.getPrimaryProducts(sessionId));
    const selectedProduct = useProductOfferStore((state) => state.getSelectedProduct(sessionId));
    const partner = usePartner();
    const activeChatId = useChatStore((state) => state.activeChatId);

    if (primaryProducts == null) {
        throw new Error("Expected data is undefined");
    }

    if (!isVoice && !isChat) {
        return () => Promise.reject(new Error("Send link is only available for voice or chat tasks"));
    }

    return async (commType: CommunicationType, contactToSend: string): Promise<SendNotificationResponse> => {
        return await sendNotification({
            sessionId,
            partner,
            productOfferId: selectedProduct?.id ?? primaryProducts[0].id,
            productSku: selectedProduct?.productSku ?? primaryProducts[0].productSku,
            customerEmailId: commType === "EMAIL" && contactToSend ? contactToSend : undefined,
            customerMdn: commType === "SMS" && contactToSend ? contactToSend : undefined,
            customerChatId: activeChatId,
            workerSid: agentId,
        });
    };
};
